import flatten from 'lodash.flatten';
import { FlowConfig } from '../../../config/FlowTypes';

/**
 * Find strings that look like images in a flow config. This will find images
 * specified in the flow config, but not images in components.
 */
export function imagesFromFlowConfig(flowConfig: FlowConfig<string>): string[] {
  return flatten(flowConfig.screens.map((screen: unknown) => deepFindImages(screen)));
}

/**
 * Recursively look through an arbitrarily deep JS object for strings that look like image paths
 */
function deepFindImages(obj: unknown): string[] {
  if (typeof obj === 'string') {
    return isStringImagePath(obj) ? [obj] : [];
  } else if (typeof obj !== 'object') {
    return [];
  }
  const valuesToRecurseInto = Array.isArray(obj) ? obj : Object.values(obj ?? {});
  return flatten(valuesToRecurseInto.map(deepFindImages));
}

/**
 * Check if string looks like a valid image path
 */
export function isStringImagePath(str: string): boolean {
  const validImageExtensions = ['.png', '.svg', '.jpg', '.jpeg'];
  const hasValidExtension = validImageExtensions.some((ext) => str.endsWith(ext));
  const hasWhitespace = /\s/.test(str);
  return hasValidExtension && !hasWhitespace;
}
